// eslint-disable-next-line
const moment = require('moment');

export enum DATE_FORMATS {
  SYSTEM_DEFAULT = 'YYYY-MM-DD HH:mm:ss Z',
  CUSTOMER_READABLE = 'YYYY-MM-DD hh:mm a',
  DATE = 'YYYY-MM-DD',
  MONTH = 'MM',
  YEAR = 'YYYY',
  YEAR_MONTH = 'YYYY-MM',
  DD_MM_YYYY = 'DD-MM-YYYY',
  DATE_MMM = 'YYYY-MMM-DD',
  DATE_MMM_TIME = 'YYYY-MMM-DD hh:mm a',
  UTC_FORMAT = 'YYYY-MM-DD hh:mm A Z',
  DATE_MM_TIME = 'YYYY-MM-DD hh:mm Z',
  DATE_TIME = 'YYYY-MM-DD HH:mm',
  DATE_TIME_SEC = 'YYYY-MM-DD HH:mm:ss',
  TIME_HH_MM_SS = 'HH:mm:ss',
  DATE_TIME_SEC_A = 'YYYY-MM-DD hh:mm:ss A',
  DATE_MMM_TIME_A = 'YYYY-MMM-DD hh:mm A',
}

export const toLocalTimeFormatted = (
  utcDatetime: string | undefined,
  format: DATE_FORMATS = DATE_FORMATS.CUSTOMER_READABLE
) => {
  utcDatetime += 'Z';
  return moment(utcDatetime).format(format);
};

export const getCurrentTimeFormatted = (format = DATE_FORMATS.SYSTEM_DEFAULT) => {
  return moment().utc().format(format);
};

export const formateDate = (date, format) => {
  return moment(date).format(format);
};

export const isHoliday = (date, format) => {
  const day = moment(date, format).toDate().getDay();
  return day === 5 || day === 6;
};
